import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var ComputerIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M38.1699 11.9999H9.82983C9.32408 12.0026 8.8398 12.2046 8.48218 12.5623C8.12455 12.9199 7.92255 13.4042 7.91992 13.9099V31.6299C7.92256 32.1348 8.125 32.618 8.48291 32.9741C8.84082 33.3301 9.325 33.53 9.82983 33.53H19.23L18.97 36.2499H15.76C15.4683 36.2499 15.1885 36.3659 14.9822 36.5721C14.7759 36.7784 14.6599 37.0582 14.6599 37.3499C14.6599 37.6417 14.7759 37.9215 14.9822 38.1277C15.1885 38.334 15.4683 38.45 15.76 38.45H32.24C32.5317 38.45 32.8115 38.334 33.0178 38.1277C33.2241 37.9215 33.3398 37.6417 33.3398 37.3499C33.3398 37.0582 33.2241 36.7784 33.0178 36.5721C32.8115 36.3659 32.5317 36.2499 32.24 36.2499H29.02L28.72 33.53H38.1699C38.4203 33.5313 38.6685 33.4831 38.9001 33.3882C39.1318 33.2933 39.3423 33.1536 39.5198 32.977C39.6973 32.8004 39.8382 32.5905 39.9343 32.3594C40.0304 32.1282 40.0798 31.8803 40.0798 31.6299V13.9399C40.0838 13.6866 40.0373 13.435 39.9431 13.1998C39.8489 12.9646 39.709 12.7505 39.5312 12.5699C39.3535 12.3894 39.1414 12.246 38.9077 12.1481C38.674 12.0503 38.4233 11.9999 38.1699 11.9999ZM37.8799 31.33H10.1199V14.2299H37.8799V31.33Z"
  }));
});
ComputerIcon.displayName = 'ComputerIcon';
ComputerIcon.defaultProps = {
  'aria-label': 'Computer'
};
export default ComputerIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/ComputerIcon/index.js
// module id = 1812
// module chunks = 12